import type { DefaultValues, SubmitHandler } from 'react-hook-form';
import { useForm } from 'react-hook-form';

import type { IContentBlockFormBodyProps } from '~/components/molecules/ContentBlock';
import type { IContainerProps } from '~/components/utils/Container';
import type { IFormMode } from '~/helpers/types';
import type { IApiAppUserRole } from '~/lib/api/modules/Apps';
import { ContentBlock } from '~/components/molecules/ContentBlock';
import { AppUserFormMainSection } from './AppUserFormMainSection';

export type IAppUserFormValues = {
  userId?: string;
  roles?: Array<IApiAppUserRole>;
};

export type IAppUserFormProps = IContainerProps &
  Omit<
    IContentBlockFormBodyProps<IAppUserFormValues>,
    'form' | 'children' | 'onSubmit' | 'submitting'
  > & {
    mode: IFormMode;
    defaultValues?: DefaultValues<IAppUserFormValues>;
    onSubmit?: SubmitHandler<IAppUserFormValues>;
    organizationId: string;
  };

export const AppUserForm: React.FC<IAppUserFormProps> = (props) => {
  const { sx, mode, defaultValues, onSubmit, organizationId, ...other } = props;
  const form = useForm<IAppUserFormValues>({
    defaultValues,
  });

  return (
    <ContentBlock.FormBody sx={sx} form={form} onSubmit={onSubmit} {...other}>
      <AppUserFormMainSection
        form={form}
        mode={mode}
        organizationId={organizationId}
      />
    </ContentBlock.FormBody>
  );
};
